import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Role } from '@/types';
import * as api from './api';
import type { CreateUserPayload } from './api';

const usersKey = ['users'] as const;

export function useUsers(enabled = true) {
  return useQuery({ queryKey: usersKey, queryFn: api.listUsers, enabled });
}

export function useCreateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateUserPayload) => api.createUser(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: usersKey }),
  });
}

export function useUpdateUserRole() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, role }: { id: string; role: Role }) => api.updateUserRole(id, role),
    onSuccess: () => qc.invalidateQueries({ queryKey: usersKey }),
  });
}

export function useDeleteUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deleteUser(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: usersKey }),
  });
}
